var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("控制中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'Branches'
      }
    }
  }, [_vm._v("分店管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("分店選單")])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 d-flex items-center justify-content-between"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("分店選單編輯")])])]), _c('div', {
    staticClass: "menu-editor-container"
  }, [_c('VueDraggable', {
    attrs: {
      "options": {
        handle: '.sort-handle',
        animation: 200
      }
    },
    on: {
      "end": _vm.onMenuItemsReorder
    },
    model: {
      value: _vm.menuItems,
      callback: function callback($$v) {
        _vm.menuItems = $$v;
      },
      expression: "menuItems"
    }
  }, _vm._l(_vm.menuItems, function (menuItem, index) {
    return _c('div', {
      key: index,
      staticClass: "menu-item-row d-flex align-items-center mb-3 p-3 border rounded"
    }, [_c('div', {
      staticClass: "sort-handle mr-3",
      staticStyle: {
        "cursor": "move"
      }
    }, [_c('i', {
      staticClass: "mdi mdi-sort text-muted",
      staticStyle: {
        "font-size": "1.2em"
      }
    }), _c('span', {
      staticClass: "ml-2 text-secondary"
    }, [_vm._v(_vm._s(index + 1))])]), _c('div', {
      staticClass: "mr-3"
    }, [_c('b-form-checkbox', {
      attrs: {
        "switch": ""
      },
      model: {
        value: menuItem.is_enabled,
        callback: function callback($$v) {
          _vm.$set(menuItem, "is_enabled", $$v);
        },
        expression: "menuItem.is_enabled"
      }
    })], 1), _c('div', {
      staticClass: "mr-3",
      staticStyle: {
        "width": "15em"
      }
    }, [_c('b-form-input', {
      class: {
        'is-invalid': menuItem.is_enabled && !menuItem.action.label
      },
      attrs: {
        "placeholder": "請輸入標題",
        "required": menuItem.is_enabled,
        "disabled": _vm.shouldOverwriteLabel(menuItem.action.type)
      },
      model: {
        value: menuItem.action.label,
        callback: function callback($$v) {
          _vm.$set(menuItem.action, "label", $$v);
        },
        expression: "menuItem.action.label"
      }
    }), menuItem.is_enabled && !menuItem.action.label ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1), _c('div', {
      staticClass: "mr-3",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('b-form-select', {
      class: {
        'is-invalid': menuItem.is_enabled && !menuItem.action.type
      },
      attrs: {
        "options": _vm.actionTypeOptions,
        "required": menuItem.is_enabled
      },
      on: {
        "change": function change(e) {
          return _vm.onActionTypeChange(e, index);
        }
      },
      model: {
        value: menuItem.action.type,
        callback: function callback($$v) {
          _vm.$set(menuItem.action, "type", $$v);
        },
        expression: "menuItem.action.type"
      }
    }), menuItem.is_enabled && !menuItem.action.type ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1), _c('div', {
      staticClass: "flex-grow-1"
    }, [menuItem.action.type === 'uri' ? _c('b-form-input', {
      class: {
        'is-invalid': menuItem.action.uri && !_vm.isValidUrl(menuItem.action.uri) || menuItem.is_enabled && !menuItem.action.uri
      },
      attrs: {
        "placeholder": "請輸入網址",
        "required": menuItem.is_enabled
      },
      model: {
        value: menuItem.action.uri,
        callback: function callback($$v) {
          _vm.$set(menuItem.action, "uri", $$v);
        },
        expression: "menuItem.action.uri"
      }
    }) : menuItem.action.type === 'message' ? _c('b-form-textarea', {
      class: {
        'is-invalid': menuItem.is_enabled && !menuItem.action.text
      },
      attrs: {
        "placeholder": "於此輸入的文字會傳送至聊天室",
        "rows": "2",
        "required": menuItem.is_enabled
      },
      model: {
        value: menuItem.action.text,
        callback: function callback($$v) {
          _vm.$set(menuItem.action, "text", $$v);
        },
        expression: "menuItem.action.text"
      }
    }) : _vm._e(), menuItem.action.type === 'uri' ? _c('div', [menuItem.is_enabled && !menuItem.action.uri ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v(" 此欄位為必填 ")]) : menuItem.action.uri && !_vm.isValidUrl(menuItem.action.uri) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v(" 請輸入有效的網址（必須以 http:// 或 https:// 開頭） ")]) : _vm._e()]) : _vm._e(), menuItem.is_enabled && menuItem.action.type === 'message' ? _c('div', [!menuItem.action.text ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v(" 此欄位為必填 ")]) : _vm._e()]) : _vm._e()], 1)]);
  }), 0)], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.showLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.showLoading
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" 儲存 ")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }